// src/services/queries/macro/fedRateProbabilitiesQueries.ts

import type { QueryFunction } from "@tanstack/react-query";
import { macroQueryKeys } from "@/constants/queryKeys";
import { TIME } from "@/constants/app";
import { API_BASE_URL } from "@/services";
import type { FedRateProbabilitiesResponse } from "@/types/dashboards/macro";

/**
 * Fetch Fed rate probabilities from backend API
 */
export const fetchFedRateProbabilities: QueryFunction<FedRateProbabilitiesResponse> = async ({
  signal,
}) => {
  const requestInit: RequestInit = {};
  if (signal) {
    requestInit.signal = signal;
  }

  const response = await fetch(`${API_BASE_URL}/macroIndicators/fedRateProbabilities`, requestInit);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  const data = (await response.json()) as FedRateProbabilitiesResponse;
  return data;
};

// Query options factory
export const fedRateProbabilitiesQueryOptions = () => ({
  queryKey: macroQueryKeys.fedRateProbabilities(),
  queryFn: fetchFedRateProbabilities,
  staleTime: 5 * TIME.MINUTE, // 5 minutes
  gcTime: 10 * TIME.MINUTE, // 10 minutes
  retry: 2,
  retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 30000),
});
